import React, { useState } from "react";
import {
  Calendar, MessageCircle, ArrowRight, Star, Award,
  Eye, Camera, Linkedin, Globe, GraduationCap, MapPin,
  Play, Wand2, Printer, PenLine, Smartphone, Package,
  Link2, Check, Share2, Building2, Puzzle, BookOpen,
  TrendingUp, Shield, Users, ChevronRight
} from "lucide-react";

const PUZZLE_IMG = "https://static.prod-images.emergentagent.com/jobs/9aee3f9a-9ba9-47c5-9ef1-87f76cda4250/images/fb7afdb376edc9f259896097cd88bc221876c0a7b7d59bd610713c909a009c00.png";
const PWA_IMG = "https://static.prod-images.emergentagent.com/jobs/c2e7986e-611e-40f0-8a3b-2eb84b9e2249/images/c4778116e83614963ed19c5cd0240f393ea60e55246f464b3d1c0fa400cbb348.png";
const GOOGLE_CARD = "https://customer-assets.emergentagent.com/job_5efdd782-584e-41f8-94c7-665072b1a298/artifacts/ij8eo9rn_chrome_zxPWiVc83A.png";
const PENS_ALL = "https://static.prod-images.emergentagent.com/jobs/5efdd782-584e-41f8-94c7-665072b1a298/images/1af9598c3ab41814b03fadda5eb969e204577a2e529233163652411316dad110.png";
const STAND_IMG = "https://static.prod-images.emergentagent.com/jobs/5efdd782-584e-41f8-94c7-665072b1a298/images/b71cf704d84e79a2e485dfbd389f625f88f2d81657315904b856aac6606f8373.png";
const BEFORE_AFTER = "https://static.prod-images.emergentagent.com/jobs/5efdd782-584e-41f8-94c7-665072b1a298/images/ad457cf266977af4d7db3c7b819f2bbdb77f829dc95a3796302ec2558b4f38de.png";

const Divider = ({ label }) => (
  <div className="w-full max-w-md flex items-center gap-4 my-5">
    <div className="flex-1 h-px bg-gray-700"></div>
    <span className="text-gray-400 text-[10px] uppercase tracking-widest font-google">{label}</span>
    <div className="flex-1 h-px bg-gray-700"></div>
  </div>
);

const LinktreePage = () => {
  const siteUrl = window.location.origin;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(siteUrl + '/links')}&color=ff6b35&bgcolor=faf8f5`;
  const [copied, setCopied] = useState(null);

  const copyLink = (url, key) => {
    navigator.clipboard.writeText(url);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  const shareLink = async (url, title) => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch {}
    } else { copyLink(url, 'share'); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-[#3D1517] flex flex-col items-center px-4 py-8">

      {/* === HEADER: schedabusiness Hub === */}
      <div className="text-center mb-6">
        <div className="w-20 h-20 mx-auto mb-3 bg-white rounded-full shadow-2xl overflow-hidden flex items-end justify-center relative">
          <img src="https://customer-assets.emergentagent.com/job_riccardo-sos-google/artifacts/4eu97hbx_Test%20ico%20TNX%20Ricca.png" alt="Riccardo Rossi" className="w-full h-auto object-cover absolute bottom-0" style={{ clipPath: 'inset(35% 0 0 0)', transform: 'translateY(-15%)' }} />
        </div>
        <h1 className="text-white font-black text-2xl font-google">
          <span className="text-[#4285F4]"><svg className="w-5 h-5 inline -mt-1 mr-0.5" viewBox="0 0 48 48" fill="none"><path d="M24 4C15.163 4 8 11.163 8 20C8 31 24 44 24 44C24 44 40 31 40 20C40 11.163 32.837 4 24 4Z" fill="#4285F4"/><circle cx="24" cy="20" r="8" fill="white"/><circle cx="24" cy="20" r="4" fill="#4285F4"/></svg></span>
          <span className="text-[#EA4335]">S</span><span className="text-[#FBBC04]">B</span><span className="text-[#34A853]">P</span>
          <span className="text-white text-lg ml-1">Hub</span>
        </h1>
        <p className="text-gray-400 text-[10px] tracking-widest uppercase font-google">Tutto schedabusiness in un unico link</p>
        <p className="text-gray-500 text-xs mt-1">Riccardo Rossi · Siena · Google Local Guide dal 2015</p>
        <div className="flex items-center justify-center gap-2 mt-3">
          <button onClick={() => copyLink(`${siteUrl}/links`, 'hub')}
            className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] font-bold transition-all ${copied === 'hub' ? 'bg-green-500 text-white' : 'bg-white/10 text-white border border-white/20 hover:border-[#ff6b35]/50'}`}>
            {copied === 'hub' ? <><Check className="w-3 h-3" /> Copiato!</> : <><Link2 className="w-3 h-3" /> Copia Link</>}
          </button>
          <button onClick={() => shareLink(`${siteUrl}/links`, 'schedabusiness Hub — Tutto in un unico link')}
            className="flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] font-bold bg-[#ff6b35] hover:bg-[#e55a2b] text-white">
            <Share2 className="w-3 h-3" /> Condividi
          </button>
        </div>
      </div>

      {/* === PUZZLE: Il tassello mancante === */}
      <div className="w-full max-w-md mb-5">
        <div className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl overflow-hidden">
          <img src={PUZZLE_IMG} alt="schedabusiness — Il pezzo di puzzle che mancava" className="w-full h-40 object-cover" />
          <div className="p-4 text-center">
            <p className="text-white text-sm font-bold font-google">"Il tassello <span className="text-[#ff6b35]">mancante</span>"</p>
            <p className="text-gray-400 text-[10px] mt-1">Street View + schedabusiness = Problema Risolto</p>
          </div>
        </div>
      </div>

      {/* === CONTATTI RAPIDI === */}
      <Divider label="Contattaci" />
      <div className="w-full max-w-md space-y-2.5 mb-3">
        <a href="https://wa.me/+393273839782" className="block w-full bg-[#25D366]/15 hover:bg-[#25D366]/25 border border-[#25D366]/30 hover:border-[#25D366]/60 rounded-2xl px-4 py-3.5 text-white transition-all group">
          <div className="flex items-center gap-3">
            <MessageCircle className="w-5 h-5 text-[#25D366]" />
            <span className="font-bold text-sm">WhatsApp</span>
            <span className="ml-auto text-gray-400 text-xs">+39 327 383 9782</span>
          </div>
        </a>
        <a href="https://calendly.com/riccardorossi1984" target="_blank" rel="noopener noreferrer" className="block w-full bg-white/10 hover:bg-white/15 border border-white/10 hover:border-white/20 rounded-2xl px-4 py-3.5 text-white transition-all group">
          <div className="flex items-center gap-3">
            <Calendar className="w-5 h-5 text-blue-400" />
            <span className="font-bold text-sm">Prenota Videochiamata</span>
            <span className="ml-auto text-gray-400 text-xs">Calendly</span>
          </div>
        </a>
        <a href={siteUrl} className="block w-full bg-white/10 hover:bg-white/15 border border-white/10 hover:border-white/20 rounded-2xl px-4 py-3.5 text-white transition-all group">
          <div className="flex items-center gap-3">
            <Globe className="w-5 h-5 text-[#ff6b35]" />
            <span className="font-bold text-sm">Sito Web schedabusiness</span>
            <span className="ml-auto bg-[#ff6b35] text-white text-[10px] px-2 py-0.5 rounded-full font-bold">VISITA</span>
          </div>
        </a>
      </div>

      {/* === I 5 PACCHETTI con prezzi e immagini === */}
      <Divider label="I Pacchetti" />
      <div className="w-full max-w-md space-y-2.5 mb-3">
        {/* Deducibile 100% */}
        <a href={`${siteUrl}/deducibile100`} className="block w-full bg-gradient-to-r from-[#1a3a6b]/40 to-[#4285F4]/40 hover:from-[#1a3a6b]/60 hover:to-[#4285F4]/60 border border-[#4285F4]/50 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-consulenza">
          <div className="flex items-center gap-3">
            <CheckCircle className="w-5 h-5 text-[#4285F4]" />
            <div className="flex-1">
              <span className="font-bold text-sm">Deducibile 100% · TAEG 0%</span>
              <p className="text-[10px] text-white/50">Formazione professionale · 3 rate PayPal</p>
            </div>
            <div className="text-right">
              <span className="font-black text-sm text-[#4285F4]">SCOPRI</span>
            </div>
          </div>
        </a>
        {/* Start */}
        <a href={`${siteUrl}/start`} className="block w-full bg-blue-500/15 border border-blue-500/30 hover:border-blue-400/60 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-start">
          <div className="flex items-center gap-3">
            <Play className="w-5 h-5 text-blue-400" />
            <div className="flex-1"><span className="font-bold text-sm">Start</span><p className="text-[10px] text-white/50">#DignitaDigitale</p></div>
            <div className="text-right"><span className="font-black text-sm">€99</span><p className="text-[9px] text-blue-300">€33 x3</p></div>
          </div>
        </a>
        {/* Plus */}
        <a href={`${siteUrl}/plus`} className="block w-full bg-red-500/15 border border-red-500/30 hover:border-red-400/60 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-plus">
          <div className="flex items-center gap-3">
            <Star className="w-5 h-5 text-red-400" />
            <div className="flex-1"><span className="font-bold text-sm">Plus</span><p className="text-[10px] text-white/50">Il preferito</p></div>
            <div className="text-right"><span className="font-black text-sm">€299</span><p className="text-[9px] text-red-300">IL PIU' VENDUTO</p></div>
          </div>
        </a>
        {/* Rooftop */}
        <a href={`${siteUrl}/rooftop`} className="block w-full bg-amber-500/15 border border-amber-500/30 hover:border-amber-400/60 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-rooftop">
          <div className="flex items-center gap-3">
            <TrendingUp className="w-5 h-5 text-amber-400" />
            <div className="flex-1"><span className="font-bold text-sm">Rooftop</span><p className="text-[10px] text-white/50">TUTTO + Assistenza Premium 12 mesi</p></div>
            <div className="text-right"><span className="font-black text-sm">€599</span><p className="text-[9px] text-amber-300">€49,91/mese</p></div>
          </div>
        </a>
        {/* Virtual Tour 360 */}
        <a href={`${siteUrl}/deducibile100`} className="block w-full bg-teal-500/15 border border-teal-500/30 hover:border-teal-400/60 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-virtual-tour-360">
          <div className="flex items-center gap-3">
            <Camera className="w-5 h-5 text-teal-400" />
            <div className="flex-1"><span className="font-bold text-sm font-typewriter">Virtual Tour 360°</span><p className="text-[10px] text-white/50">Virtual Tour GoPro MAX</p></div>
            <div className="text-right"><span className="font-black text-sm">€499</span><p className="text-[9px] text-teal-300">START INCLUSO</p></div>
          </div>
        </a>
      </div>

      {/* === RECENSIONI (preview Google) === */}
      <Divider label="Recensioni Google" />
      <div className="w-full max-w-md mb-3">
        <div className="flex justify-center mb-4">
          <img src={GOOGLE_CARD} alt="5,0 stelle su Google" className="h-24 rounded-xl shadow-lg" />
        </div>
        <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6">
          <p className="text-white text-base italic text-center leading-relaxed font-google">"Persona molto professionale e seria.. Ha risolto il problema della mia scheda Google in poche ore."</p>
          <p className="text-gray-400 text-sm text-center mt-4 font-semibold">— Gelateria Buekke · e altre 49 recensioni a 5 stelle</p>
        </div>
      </div>

      {/* === CONVENZIONE ENTI === */}
      <Divider label="Per Enti e Associazioni" />
      <div className="w-full max-w-md mb-3">
        <a href={`${siteUrl}/enti`} className="block w-full bg-green-500/10 hover:bg-green-500/20 border border-green-500/30 hover:border-green-400/60 rounded-2xl px-5 py-5 text-white transition-all" data-testid="hub-enti">
          <div className="flex items-center gap-3">
            <Building2 className="w-7 h-7 text-green-400" />
            <div className="flex-1">
              <span className="font-bold text-base">Convenzione Enti — Opzione C</span>
              <p className="text-sm text-white/60 mt-0.5">50 e 50: €99,50 Ente + €99,50 iscritto · Deducibile 100%</p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-2.5 mt-4">
            {[
              { n: "10", p: "€199" },
              { n: "20", p: "€179", badge: "-10%" },
              { n: "30", p: "€159", badge: "-20%" },
              { n: "50+", p: "€139", badge: "-30%" },
            ].map((t) => (
              <div key={t.n} className="bg-white/5 rounded-lg p-2.5 text-center">
                <div className="text-xs text-gray-400">{t.n} iscritti</div>
                <div className="text-base font-black text-white">{t.p}</div>
                {t.badge && <div className="text-xs text-green-400 font-bold">{t.badge}</div>}
              </div>
            ))}
          </div>
        </a>
      </div>

      {/* === PWA App === */}
      <Divider label="L'App in regalo con la scelta di un pacchetto" />
      <div className="w-full max-w-md mb-3">
        <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <div className="flex justify-center bg-black/20 py-6">
            <img src={PWA_IMG} alt="schedabusiness tra Google Maps e WhatsApp" className="w-full max-w-xs rounded-xl" />
          </div>
          <div className="p-5 text-center">
            <p className="text-white text-lg font-bold font-google">In regalo per sempre!</p>
            <p className="text-white/40 text-xs mt-1">Lo trovi con l'acquisto di un pacchetto: Start, Plus, Rooftop o Virtual Tour 360°</p>
            <p className="text-white/40 text-sm italic mt-2">"Abbiamo reinventato un terzo luogo tra ufficio e Google"</p>
          </div>
        </div>
      </div>

      {/* === CROSS-SELLING === */}
      <Divider label="Merchandising schedabusiness" />
      <div className="w-full max-w-md space-y-2.5 mb-3">
        <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <img src={PENS_ALL} alt="4 penne schedabusiness nei colori dei pacchetti" className="w-full h-32 object-cover" />
          <div className="p-3">
            <p className="text-white text-sm font-bold">Penna schedabusiness — REGALO con ogni pacchetto</p>
            <p className="text-gray-400 text-[10px]">Blu (Start) · Rossa (Plus) · Ambra (Rooftop) · Verde (virtual-tour-360)</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2.5">
          <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
            <img src={STAND_IMG} alt="Base smartphone bambu schedabusiness" className="w-full h-24 object-cover" />
            <div className="p-2.5"><p className="text-white text-xs font-bold">Base Smartphone</p><p className="text-amber-400 text-xs font-black">€29,99</p></div>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-2xl p-3 flex flex-col justify-center">
            <p className="text-white text-xs font-bold mb-1">100 Penne con il TUO Logo</p>
            <p className="text-[#ff6b35] text-lg font-black">€199</p>
            <p className="text-gray-400 text-[9px]">+ IVA · Bundle -20%</p>
          </div>
        </div>
      </div>

      {/* === LOCAL SEO (Hidden — reserved for future use) === */}
      {/*
      <Divider label="Local SEO" />
      <div className="w-full max-w-md mb-3">
        <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <img src={BEFORE_AFTER} alt="Prima e Dopo la Local SEO" className="w-full h-40 object-cover" />
          <div className="p-3 text-center">
            <p className="text-white text-sm font-bold font-google">Prima e dopo <span className="text-amber-400">Rooftop</span></p>
            <p className="text-gray-400 text-[10px]">La SEO locale che ti fa trovare per primo su Google</p>
          </div>
        </div>
      </div>
      */}

      {/* === ECOSISTEMA GOOGLE === */}
      <Divider label="Ecosistema Google" />
      <div className="w-full max-w-md space-y-2.5 mb-3">
        <a href="https://workspace.google.com/intl/it/contact/" target="_blank" rel="noopener noreferrer" className="block bg-[#4285F4]/15 border border-[#4285F4]/30 hover:border-[#4285F4]/60 rounded-2xl px-4 py-3 text-white transition-all">
          <div className="flex items-center gap-3"><Globe className="w-4 h-4 text-[#4285F4]" /><span className="text-sm">Google Workspace — Email professionale</span></div>
        </a>
        <a href="https://fonts.google.com/" target="_blank" rel="noopener noreferrer" className="block bg-white/5 border border-white/10 hover:border-white/20 rounded-2xl px-4 py-3 text-white transition-all">
          <div className="flex items-center gap-3"><BookOpen className="w-4 h-4 text-red-400" /><span className="text-sm">Google Fonts — Font per il TUO brand</span></div>
        </a>
        <a href="https://maps.google.com/localguides/" target="_blank" rel="noopener noreferrer" className="block bg-[#34A853]/15 border border-[#34A853]/30 hover:border-[#34A853]/60 rounded-2xl px-4 py-3 text-white transition-all">
          <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#34A853]" /><span className="text-sm">Google Local Guides</span><span className="ml-auto bg-[#34A853]/30 text-[#34A853] text-[10px] px-2 py-0.5 rounded-full font-bold">DAL 2015</span></div>
        </a>
      </div>

      {/* === LINKEDIN === */}
      <div className="w-full max-w-md mb-3">
        <a href="https://www.linkedin.com/in/riccardorossi1984googletnx/" target="_blank" rel="noopener noreferrer" className="block bg-[#0077B5]/20 border border-[#0077B5]/30 hover:border-[#0077B5]/60 rounded-2xl px-4 py-3.5 text-white transition-all">
          <div className="flex items-center gap-3"><Linkedin className="w-5 h-5 text-[#0077B5]" /><span className="font-bold text-sm">LinkedIn</span><span className="ml-auto bg-[#D4AF37] text-gray-900 text-[10px] px-2 py-0.5 rounded-full font-bold">PREMIUM</span></div>
        </a>
      </div>

      {/* === BRAND KIT TIPOGRAFIA === */}
      <Divider label="Brand Kit / Tipografia" />
      <div className="w-full max-w-md space-y-2.5 mb-5">
        <a href={`${siteUrl}/brand-kit`} className="block bg-[#ff6b35]/15 border border-[#ff6b35]/30 hover:border-[#ff6b35]/60 rounded-2xl px-4 py-3.5 text-white transition-all" data-testid="hub-brandkit">
          <div className="flex items-center gap-3">
            <Printer className="w-5 h-5 text-[#ff6b35]" />
            <div className="flex-1"><span className="font-bold text-sm">Brand Identity Kit</span><p className="text-[10px] text-white/50">Loghi, Pantone, font, penne, specifiche stampa</p></div>
            <span className="bg-[#ff6b35] text-white text-[10px] px-2 py-0.5 rounded-full font-bold">APRI</span>
          </div>
        </a>
        <div className="flex gap-2">
          <button onClick={() => copyLink(`${siteUrl}/brand-kit`, 'bk')}
            className={`flex-1 flex items-center justify-center gap-1 py-2 rounded-xl text-[10px] font-bold transition-all ${copied === 'bk' ? 'bg-green-500 text-white' : 'bg-white/10 text-white border border-white/10'}`}>
            {copied === 'bk' ? <><Check className="w-3 h-3" /> Copiato!</> : <><Link2 className="w-3 h-3" /> Copia Link Brand Kit</>}
          </button>
          <button onClick={() => shareLink(`${siteUrl}/brand-kit`, 'schedabusiness — Brand Kit per Tipografia')}
            className="flex items-center justify-center gap-1 px-3 py-2 rounded-xl text-[10px] font-bold bg-[#ff6b35] hover:bg-[#e55a2b] text-white">
            <Share2 className="w-3 h-3" /> Invia alla Tipografia
          </button>
        </div>
      </div>

      {/* === QR CODE === */}
      <div className="text-center mb-6">
        <p className="text-gray-500 text-[10px] mb-1">Scansiona per condividere schedabusiness Hub</p>
        <div className="inline-block bg-white rounded-2xl p-3 shadow-lg relative">
          <img src={qrUrl} alt="QR Hub" className="w-28 h-28" data-testid="qr-hub" />
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="bg-white rounded-full p-1 shadow-md">
              <svg className="w-4 h-4" viewBox="0 0 48 48" fill="none"><path d="M24 4C15.163 4 8 11.163 8 20C8 31 24 44 24 44C24 44 40 31 40 20C40 11.163 32.837 4 24 4Z" fill="#4285F4"/><circle cx="24" cy="20" r="8" fill="white"/><circle cx="24" cy="20" r="4" fill="#4285F4"/></svg>
            </div>
          </div>
        </div>
      </div>

      {/* === FOOTER === */}
      <div className="text-center pb-4">
        <div className="flex items-center justify-center gap-1 mb-1">
          <svg className="w-4 h-4" viewBox="0 0 48 48" fill="none"><path d="M24 4C15.163 4 8 11.163 8 20C8 31 24 44 24 44C24 44 40 31 40 20C40 11.163 32.837 4 24 4Z" fill="#4285F4"/><circle cx="24" cy="20" r="8" fill="white"/><circle cx="24" cy="20" r="4" fill="#4285F4"/></svg>
          <span className="font-black text-sm font-google"><span className="text-[#EA4335]">S</span><span className="text-[#FBBC04]">B</span><span className="text-[#34A853]">P</span></span>
          <span className="text-gray-500 text-xs ml-1">Hub</span>
        </div>
        <p className="text-gray-600 text-[10px] font-google">Business Profile Solutions · Made in Toscana</p>
      </div>
    </div>
  );
};

export default LinktreePage;
